/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Diagnosis from './Diagnosis/index'
import HelpTooltip from './HelpTooltip/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconMonitorHeart from 'DesignSystem/Svgs/TysiaIconMonitorHeart/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/DiagnosisAction/Content",
  hovered,
  onMouseEnter,
  onMouseLeave,
  onSubmit,
  isSubmitting
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let createDiagnosisSubmitData = fromData.useDataSubmit({ viewPath,
context: 'create_diagnosis',
})
let createDiagnosisIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'create_diagnosis',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 data="create_diagnosis"
 onClick={createDiagnosisSubmitData}
 disabled={createDiagnosisIsSubmittingData}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconMonitorHeart
{...childProps}
  viewPath={`${viewPath}/TysiaIconMonitorHeart`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<HelpTooltip
  viewPath={`${viewPath}/HelpTooltip`}
 hovered={hovered}
/>
</div>
<Diagnosis
  viewPath={`${viewPath}/Diagnosis`}
/>
{children}
</React.Fragment>)
}